
export enum OutboundWebhookStrategy {
  OkeokeProducts = 'OkeokeProducts',
}
